export default "__VITE_ASSET__M0T9C$K7__"